import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HelptNotFound = () => {
    const { t } = useTranslation(['common']);
    const navigate = useNavigate();

    const navigateToHelp = () => {
        navigate('/help', { replace: true });
    }

    return (
        <div className="text-center mt-4">
            <h2>{t('notFound.title', { ns: 'common' })}</h2>
            <p>{t('notFound.message', { ns: 'common' })}</p>
            <Button onClick={navigateToHelp} color="flowsync" className="mt-4">{t('help.toHelp', { ns: 'common' })}</Button>
        </div>
    )
}

export default HelptNotFound;
